/**
 * Created by eliranm on 30/10/14.
 *
 * Handles instantiation of FileUploadInputModel by permutation. Sets the permutation dependent properties accordingly and
 * returns a new FileUploadInputModel.
 *
 */
define(function (require) {
    'use strict';

    var _ = require('underscore');
    var logger = require('logger').getLogger('FileUploadInputModelFactory');
    var Utils = require('ui/file-upload-input/js/FileUploadInputUtils');
    var Config = require('ui/file-upload-input/config/fileUploadInputConfig.json');
    var FileUploadInputModel = require('ui/file-upload-input/js/models/FileUploadInputModel');
    var Bubble = require("ui/bubble/Bubble");
    var Translator = require("i18n/translator");

    return {

        create: function (options) {

            var msg, instance;

            if (!options) {
                msg = 'options must be passed to the model factory. cannot create model, aborting instantiation.';
                logger.error(msg);
                logger.graph({ name: "UIComponents:FileUploadInputModelFactory:missingOptions"});
                throw new Error(msg);
            }

            options = this._prepareOptions(options);

            switch (options.permutation) {
                case Config.permutation.DEFAULT:
                    instance = this._createDefaultModel(options);
                    break;
                case Config.permutation.NATIVE:
                    instance = this._createNativeModel(options);
                    break;
                case Config.permutation.CUSTOM:
                    instance = this._createCustomModel(options);
                    break;
                default:
                    break;
            }

            if (!instance) {
                msg = 'could not create model instance from options "' + options + '"';
                logger.error(msg);
                logger.graph({ name: "UIComponents:FileUploadInputModelFactory:instanceNotCreated"});
                throw new Error(msg);
            }

            return instance;
        },

        _createNativeModel: function (options) {
            return new FileUploadInputModel(_.extend(options, {
                buttonStyle: '',
                nativeStyles: true
            }));
        },

        _createDefaultModel: function (options) {
            return new FileUploadInputModel(_.extend(options, {
                buttonStyle: Config.fileUploadTransport.chooseButtonStyleDefaultButton
            }));
        },

        _createCustomModel: function (options) {
            return new FileUploadInputModel(options);
        },

        _prepareOptions: function (options) {
            this._validateMandatoryOptions(options);
            options = this._assignDefaultOptions(options);
            this._validateOptionsTypes(options);
            return options;
        },

        /**
         * Validates the passed options object by checking the mandatory properties.
         * @param options
         * @private
         */
        _validateMandatoryOptions: function (options) {
            Utils.validateExists(options, ['uploadUrl']);
        },

        /**
         * Fills in undefined properties of the options object.
         * This function handles the options object optional properties.
         * @param options
         * @returns {*} The modified options object.
         * @private
         */
        _assignDefaultOptions: function (options) {

            var defaultOptions = {
                permutation: Config.permutation.DEFAULT,
                buttonText: '',
                buttonStyle: '',
                nativeStyles: Config.fileUploadTransport.defaults.nativeStyles,
                iFrameTitle: Translator.translate("LEUIComponents.upload.iframeTitle.tooltip"),
                uploadExtensions: [],
                uploadTimeout: Config.fileUploadTransport.defaults.uploadTimeout,
                iFrameLoadTimeout: Config.fileUploadTransport.defaults.iFrameLoadTimeout,
                classNames: [],
                errorPosition: Bubble.POSITION.TOP
            };

            return Utils.assignDefaults(options, defaultOptions);
        },

        _validateOptionsTypes: function (options) {
            Utils.validateTypeArray(options, ['classNames', 'uploadExtensions']);
        }

    };
});
